import Vue from 'vue'
import FormWidgetRule from './form-widget-rule.config'

const apis = {
  QUERY_LIST_BUSINESS_DATA: {
    url: '/xdap-app/business/query/newDataSelectorData',
    // url: '/xdap-app/business/query/listPageBusinessData',
    method: 'post',
    disableSuccessMsg: true
  },
  QUERY_ALL_BUSINESS_DATA: {
    url: '/xdap-app/business/query/allSelectorData',
    method: 'get',
    disableSuccessMsg: true
  }
}

const FormOtherTableFieldConfig = {
  componentType: 'FORM_OTHER_TABLE_FIELD',
  widgetConfig: {
    icon: 'form-other-table-field',
    text: '他表字段',
    optionTitle: true,
    description: '用于展示其他表单的数据字段'
  },
  componentConfig: {
    ...FormWidgetRule,
    uuid: `32bit uuid`,
    width: 6, // 3, 6, 9, 12
    height: 1,
    label: '他表字段',
    placeholder: '请选择数据源',
    render: {
      ide: 'FormOtherTableField',
      edit: 'FormOtherTableField',
      read: 'FormOtherTableField'
    },
    documentNumRules: [],
    readOnly: true,
    inTable: true,
    dataSelector: {
      type: 'LOV_CHOOSE'
    },
    methods: {
      lcInitData: {
        edit: (...args) => {
          console.log(args)
        }
      },
      lcLoadRemoteData: (
        config,
        formData,
        globalData,
        formConfigList,
        type,
        pageInfo,
        keyWord = '',
        isQueryAllData
      ) => {
        let request = {
          ...apis.QUERY_LIST_BUSINESS_DATA
        }
        if (isQueryAllData) {
          request = {
            ...apis.QUERY_ALL_BUSINESS_DATA
          }
        }
        request.params = {
          ...pageInfo,
          formId: config.dataSelector.otherFormId,
          componentId: '83e485f0-d5a3-50cd-413a-1dcd946d4e08'
        }
        if (!isQueryAllData) {
          request.params.keyWord = keyWord
          request.params.data = formData
        }
        return Vue.prototype.$request(request).then((resp) => {
          return {
            data: resp.data.map((item) => {
              return {
                value: item.documentId,
                label: item[config.dataSelector.otherComponent],
                extra: item
              }
            }),
            total: resp.total
          }
        })
      }
    }
  },
  editorConfig: [
    'INFO',
    'LABEL',
    'LOV_CHOOSETYPE',
    'WIDTH',
    'HIDDEN'
  ],
  excludeEditorConfigInTable: ['WIDTH']
}

export default FormOtherTableFieldConfig
